import { includes } from 'lodash';
import { UserDetails } from '../users/UserContext';

export type Permission = 'View' | 'Edit' | 'Manually Trigger Parts Update' | 'Manually Trigger Customers Update';

export const userHasPermission = ({ user, permission }: { user: UserDetails; permission: Permission }) =>
  includes(user.permissions, permission);
